import React, { createContext, useContext, useMemo, useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { useAuth } from '../Auth/AuthProvider';
import { useAdminResource } from '../TenantAdmin/shared';
import { createPlatformApi, platformError, seatPackages } from './api';

const PlatformContext = createContext(null);
export function PlatformProvider({ children }) {
  const { session } = useAuth();
  const api = useMemo(() => createPlatformApi(session.api), [session]);
  return <PlatformContext.Provider value={api}>{children}</PlatformContext.Provider>;
}
export const usePlatformApi = () => useContext(PlatformContext);
export const usePlatformResource = loader => useAdminResource(loader, platformError);

export function OfferingFields({ offerings, value, onChange, disabled }) {
  const selected = offerings.find(o => o.code === value.offeringCode);
  return <>
    <Form.Group controlId="offering-code"><Form.Label>Offering</Form.Label>
      <Form.Select required disabled={disabled} value={value.offeringCode} onChange={e => {
        const next = offerings.find(o => o.code === e.target.value);
        const seats = seatPackages(next);
        onChange({ ...value, offeringCode: e.target.value, allocatedSeats: seats.includes(value.allocatedSeats) ? value.allocatedSeats : seats[0] });
      }}><option value="">Select an offering</option>{offerings.map(o => <option key={o.code} value={o.code}>{o.displayName || o.code} ({o.code})</option>)}</Form.Select>
    </Form.Group>
    <Form.Group controlId="allocated-seats"><Form.Label>Allocated seats</Form.Label><Form.Select disabled={disabled || !selected} value={value.allocatedSeats} onChange={e => onChange({ ...value, allocatedSeats: Number(e.target.value) })}>
      {seatPackages(selected).map(n => <option key={n} value={n}>{n}</option>)}
    </Form.Select></Form.Group>
    {selected && <p>Included entitlements: {selected.entitlements?.length ? selected.entitlements.join(', ') : 'None returned'}. {selected.trial && 'TRIAL: 10 seats; new trial onboarding lasts 30 days.'}</p>}
  </>;
}

// Confirmation stores a snapshot of the user's proposed change; no privileged mutation
// happens until explicitly confirmed. Failed mutations are not automatically repeated.
export function useConfirmedMutation() {
  const [pending, setPending] = useState(null); const [busy, setBusy] = useState(false);
  const [error, setError] = useState(''); const [notice, setNotice] = useState('');
  const confirm = async () => {
    setBusy(true); setError(''); setNotice('');
    try { await pending.run(); setNotice(pending.success || 'Change saved.'); }
    catch (failure) { setError(platformError(failure)); }
    finally { setBusy(false); setPending(null); }
  };
  return { busy, request: options => { setError(''); setNotice(''); setPending(options); }, feedback: <>
    {error && <Alert variant="danger" role="alert">{error}</Alert>}
    {notice && <Alert variant="success" role="status">{notice}</Alert>}
    <Modal show={!!pending} onHide={() => !busy && setPending(null)} className="tenant-admin-modal" backdropClassName="ta-modal-backdrop" aria-labelledby="platform-confirm-title" centered>
      <Modal.Header><Modal.Title as="h2" id="platform-confirm-title">{pending?.title}</Modal.Title></Modal.Header>
      <Modal.Body>{pending?.description}</Modal.Body><Modal.Footer>
        <Button variant="outline-secondary" disabled={busy} onClick={() => setPending(null)}>Cancel</Button>
        <Button variant="danger" disabled={busy} onClick={confirm}>{busy ? 'Saving…' : 'Confirm change'}</Button>
      </Modal.Footer>
    </Modal>
  </> };
}
